import styled from 'styled-components';

import CircleCheck from 'hb-react/shared/icons/CircleCheck';
import ExclamationMark from 'hb-react/shared/icons/ExclamationMark';
import Paused from 'hb-react/shared/icons/Paused';
import Pending from 'hb-react/shared/icons/Pending';

import {
  ACCEPTED,
  REJECTED,
  ON_PAUSE,
  PENDING,
  REJECTED_CAN_REAPPLY,
} from '../../constants';

const StatusIcon = ({ status }) => {
  switch (status) {
    case ACCEPTED:
      return (
        <Wrapper>
          <CircleCheck width="20px" height="20px" />
        </Wrapper>
      );
    case ON_PAUSE:
      return (
        <Wrapper>
          <Paused width="28px" height="28px" />
        </Wrapper>
      );
    case PENDING:
      return (
        <Wrapper>
          <Pending width="28px" height="28px" />
        </Wrapper>
      );
    case REJECTED:
    case REJECTED_CAN_REAPPLY:
      return (
        <Wrapper>
          <ExclamationMark width="25px" height="25px" />
        </Wrapper>
      );
    default:
      return null;
  }
};

export default StatusIcon;

const Wrapper = styled.div`
  position: absolute;
  top: 38px;
  right: 0;
`;
